import { startCase } from "lodash";
import moment from "moment";
import React, { useState } from "react";
import { formatWithCommas } from "../../Utils/Toast";

const TransactionRecordDetail = ({ detail, setDetail }) => {
  console.log(detail, "detail");
  const [show, setShow] = useState(true);
  return (
    <>
      <div
        _ngcontent-serverapp-c3748548866
        className="pop-transaction-records-details ng-tns-c3748548866-77 ng-trigger ng-trigger-popWrapTriggerAni active ng-star-inserted"
      >
        <div
          _ngcontent-serverapp-c3748548866
          className="bank-name ng-tns-c3748548866-77"
        >
          <img
            _ngcontent-serverapp-c3748548866
            className="ng-tns-c3748548866-77"
            alt="bkash"
            src="/assets/Other/bkash.png"
            loading="lazy"
          />
          <span
            _ngcontent-serverapp-c3748548866
            className="ng-tns-c3748548866-77"
          >
            bkash
          </span>
        </div>
        <a
          onClick={() => setDetail({})}
          _ngcontent-serverapp-c3748548866
          className="btn-closed ng-tns-c3748548866-77"
          style={{
            "mask-image":
              'url("/assets/Other/icon-close.svg")',
          }}
        />
        <div
          _ngcontent-serverapp-c3748548866
          className="header ng-tns-c3748548866-77"
        >
          {" "}
          Transaction Record Details{" "}
        </div>
        <div
          _ngcontent-serverapp-c3748548866
          // processing
          // fail
          className={`content pop-content ng-tns-c3748548866-77 ${
            ["declined", "Expired Payment Link"].includes(detail?.status)
              ? "fail"
              : detail?.status == "completed"
              ? "success"
              : "processing"
          } `}
        >
          <app-tab-button-not-link
            _ngcontent-serverapp-c3748548866
            className="ng-tns-c3748548866-77"
            _nghost-serverapp-c392657124
          >
            <div
              _ngcontent-serverapp-c392657124
              data-tab-tabbtn={0}
              className="tab-btn-section"
            >
              <div
                _ngcontent-serverapp-c392657124
                data-session
                className="tab-btn tab-btn-page"
              >
                <div
                  _ngcontent-serverapp-c392657124
                  className="line"
                  style={{
                    width: "calc(50%)",
                    "-webkit-transform": "translate(0%, 0px)",
                    "-ms-transform": "translate(0%, 0px)",
                    transform: show
                      ? "translate(0%, 0px)"
                      : "translate(100%, 0px)",
                  }}
                />
                <div
                  onClick={() => setShow(true)}
                  _ngcontent-serverapp-c392657124
                  className="btn ng-star-inserted"
                  data-tab-current={show ? "current" : ""}
                >
                  <img _ngcontent-serverapp-c392657124 className="icon" />
                  <div _ngcontent-serverapp-c392657124 className="text">
                    Transaction Progress
                  </div>
                </div>
                <div
                  onClick={() => setShow(false)}
                  _ngcontent-serverapp-c392657124
                  className="btn ng-star-inserted"
                  data-tab-current={!show ? "current" : ""}
                >
                  <img _ngcontent-serverapp-c392657124 className="icon" />
                  <div _ngcontent-serverapp-c392657124 className="text">
                    Transaction Details
                  </div>
                </div>
              </div>
            </div>
          </app-tab-button-not-link>
          <div
            _ngcontent-serverapp-c3748548866
            className="tab-content tab-content-page ng-tns-c3748548866-77"
          >
            <div
              _ngcontent-serverapp-c3748548866
              className="inner-wrap ng-tns-c3748548866-77"
              style={{
                "-webkit-transform": "translate(0%, 0px)",
                "-ms-transform": "translate(0%, 0px)",
                transform: show
                  ? "translate(0%, 0px)"
                  : "translate(-100%, 0px)",
              }}
            >
              <div
                _ngcontent-serverapp-c3748548866
                className="inner-box ng-tns-c3748548866-77"
                style={{ height: "auto" }}
                data-tab-current={show ? "current" : ""}
              >
                <div
                  _ngcontent-serverapp-c3748548866
                  className="transaction-details-wrap ng-tns-c3748548866-77"
                >
                  <div
                    _ngcontent-serverapp-c3748548866
                    className="title ng-tns-c3748548866-77"
                  >
                    <h3
                      _ngcontent-serverapp-c3748548866
                      className="ng-tns-c3748548866-77"
                    >
                      Transaction Progress
                    </h3>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="tags ng-tns-c3748548866-77"
                    >
                      {detail?.status == "Expired Payment Link"
                        ? "Expired"
                        : detail?.status == "completed"
                        ? "Approved"
                        : detail?.status == "requested"
                        ? "Processing"
                        : startCase(detail?.status)}
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c3748548866
                    className="timeline-box ng-tns-c3748548866-77"
                  >
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="date ng-tns-c3748548866-77 ng-star-inserted"
                    >
                      {moment(detail?.createdAt).format("YYYY/MM/DD")}
                    </div>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className={`timeline-block ng-tns-c3748548866-77 ${
                        [
                          "declined",
                          "Expired Payment Link",
                          "completed",
                        ].includes(detail?.status)
                          ? "current"
                          : ""
                      }  ng-star-inserted`}
                    >
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="point ng-tns-c3748548866-77 bounce"
                      >
                        <span
                          _ngcontent-serverapp-c3748548866
                          className="ng-tns-c3748548866-77 ng-star-inserted"
                          style={{
                            "mask-image":
                              'url("/assets/Other/icon-check-type06.svg")',
                          }}
                        />
                      </div>
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="content ng-tns-c3748548866-77"
                        style={{
                          "-webkit-animation":
                            "1s ease 0.2s 1 normal none running _slide",
                          animation:
                            "1s ease 0.2s 1 normal none running _slide",
                        }}
                      >
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="text ng-tns-c3748548866-77"
                        >
                          Your {startCase(detail?.type)} Is{" "}
                          {detail?.status == "completed"
                            ? "Successful"
                            : startCase(detail?.status)}{" "}
                          .
                        </div>
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="time ng-tns-c3748548866-77"
                        >
                          {moment(detail?.createdAt).format("HH:MM:SS")}
                        </div>
                      </div>
                    </div>

                    <div
                      _ngcontent-serverapp-c3748548866
                      className="date ng-tns-c3748548866-77 ng-star-inserted"
                    >
                      {moment(detail?.createdAt).format("YYYY/MM/DD")}
                    </div>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className={`timeline-block ng-tns-c3748548866-77 ${
                        ![
                          "declined",
                          "Expired Payment Link",
                          "completed",
                        ].includes(detail?.status)
                          ? "current"
                          : ""
                      }  ng-star-inserted`}
                    >
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="point ng-tns-c3748548866-77"
                      >
                        <span
                          _ngcontent-serverapp-c3748548866
                          className="ng-tns-c3748548866-77 ng-star-inserted"
                          style={{
                            "mask-image":
                              'url("/assets/Other/icon-check-type06.svg")',
                          }}
                        />
                      </div>
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="content ng-tns-c3748548866-77"
                        style={{
                          "-webkit-animation":
                            "1s ease 0.3s 1 normal none running _slide",
                          animation:
                            "1s ease 0.3s 1 normal none running _slide",
                        }}
                      >
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="text ng-tns-c3748548866-77"
                        >
                          {startCase(detail?.type)} Information Received.
                        </div>
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="time ng-tns-c3748548866-77"
                        >
                          {moment(detail?.createdAt).format("HH:MM:SS")}
                        </div>
                      </div>
                    </div>

                    <div
                      _ngcontent-serverapp-c3748548866
                      className="date ng-tns-c3748548866-77 ng-star-inserted"
                    >
                      {moment(detail?.createdAt).format("YYYY/MM/DD")}
                    </div>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="timeline-block ng-tns-c3748548866-77 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="point ng-tns-c3748548866-77"
                      >
                        <span
                          _ngcontent-serverapp-c3748548866
                          className="ng-tns-c3748548866-77 ng-star-inserted"
                          style={{
                            "mask-image":
                              'url("/assets/Other/icon-check-type06.svg")',
                          }}
                        />
                      </div>
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="content ng-tns-c3748548866-77"
                        style={{
                          "-webkit-animation":
                            "1s ease 0.4s 1 normal none running _slide",
                          animation:
                            "1s ease 0.4s 1 normal none running _slide",
                        }}
                      >
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="text ng-tns-c3748548866-77"
                        >
                          {startCase(detail?.type)} Initiated.
                        </div>
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="time ng-tns-c3748548866-77"
                        >
                          {moment(detail?.createdAt).format("HH:MM:SS")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                _ngcontent-serverapp-c3748548866
                className="inner-box ng-tns-c3748548866-77"
                style={{ height: "auto" }}
                data-tab-current={!show ? "current" : ""}
              >
                <div
                  _ngcontent-serverapp-c3748548866
                  className="transaction-details-wrap ng-tns-c3748548866-77"
                >
                  <div
                    _ngcontent-serverapp-c3748548866
                    className="title ng-tns-c3748548866-77"
                  >
                    <h3
                      _ngcontent-serverapp-c3748548866
                      className="ng-tns-c3748548866-77"
                    >
                      Transaction Record Details
                    </h3>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="tags ng-tns-c3748548866-77"
                    >
                      {detail?.status == "Expired Payment Link"
                        ? "Expired"
                        : detail?.status == "completed"
                        ? "Approved"
                        : detail?.status == "requested"
                        ? "Processing"
                        : startCase(detail?.status)}
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c3748548866
                    className="details-box ng-tns-c3748548866-77"
                  >
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="info ng-tns-c3748548866-77"
                    >
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="name ng-tns-c3748548866-77"
                      >
                        No.
                      </div>
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="value ng-tns-c3748548866-77"
                      >
                        {detail?.TransactionId}
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="info ng-tns-c3748548866-77"
                    >
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="name ng-tns-c3748548866-77"
                      >
                        Type
                      </div>
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="value ng-tns-c3748548866-77"
                      >
                        {" "}
                        {startCase(detail?.type)} Payment Gateway{" "}
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="info ng-tns-c3748548866-77"
                    >
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="name ng-tns-c3748548866-77"
                      >
                        {" "}
                        Payment Method{" "}
                      </div>
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="value ng-tns-c3748548866-77"
                      >
                        {" "}
                        bKash{" "}
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="info ng-tns-c3748548866-77"
                    >
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="name ng-tns-c3748548866-77"
                      >
                        {" "}
                        Payment Type{" "}
                      </div>
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="value ng-tns-c3748548866-77"
                      >
                        {" "}
                        bKash Payment{" "}
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="info ng-tns-c3748548866-77 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="name ng-tns-c3748548866-77"
                      >
                        {" "}
                        Bank Name{" "}
                      </div>
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="value ng-tns-c3748548866-77"
                      >
                        {detail?.bank_name || "-"}
                      </div>
                    </div>

                    <div
                      _ngcontent-serverapp-c3748548866
                      className="info ng-tns-c3748548866-77"
                    >
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="name ng-tns-c3748548866-77"
                      >
                        {" "}
                        Amount{" "}
                      </div>
                      <div
                        _ngcontent-serverapp-c3748548866
                        className="value ng-tns-c3748548866-77"
                      >
                        <i
                          id="locale-util-dicrective-49"
                          className="ng-tns-c3748548866-77"
                          style={{ display: "initial" }}
                        >
                          {formatWithCommas(detail?.amount)}
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        _ngcontent-serverapp-c3748548866
        className="pop-bg ng-tns-c3748548866-77 ng-trigger ng-trigger-popBgTriggerAni ng-star-inserted"
        style={{ display: "block" }}
      ></div>
    </>
  );
};

export default TransactionRecordDetail;
